import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import ElementPlus from 'element-plus'
import 'element-plus/dist/index.css'
import zhCn from './utils/zh-cn';
const app = createApp(App);
// 屏蔽黄色警告信息
app.config.warnHandler = () => null

// app.use(router).use(ElementPlus).mount("#app");
app.use(store).use(router).use(ElementPlus,{
    locale: zhCn
}).mount("#app");
// createApp(App).use(store).use(router).mount('#app')
